import { Link } from "react-router-dom";
import type { BeautyArticle } from "@/mocks/beauty-info";
import { scrollToTop } from "@/components/feature/ScrollToTop";

export default function RelatedArticles({ articles }: { articles: BeautyArticle[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/beauty-info/${article.id}`}
          onClick={scrollToTop}
          className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              title={`${article.title} - 비앙카 뷰티정보`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-primary-600">
              {article.category}
            </span>
          </div>
          <div className="flex flex-col gap-2 p-5 flex-1">
            <h3 className="text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
              {article.title}
            </h3>
            <span className="mt-auto pt-2 inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
              자세히 보기
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}